import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import Config from '@/constant/index'
import { toLoginPage, filterEmpty } from '@/assets/js/utils'
import { getUrlParams, cookie } from '@/utils'
import i18n from '@/i18n'
const { TOKEN_KEY, TIME_OUT } = Config
const request = ({ TOKEN_KEY = '', headers = {}, allowEmpty = false, baseUrl = '' }) => {
  const FORMAXIOS = axios.create({
    timeout: TIME_OUT,
    baseURL: baseUrl,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
  })

  /* FORM形式Request的钩子 */
  function __requestFormSuccessInterceptor(config) {
    const allowEmptyKeys = (config.data && config.data.allowEmptyKeys) || undefined
    // allowEmptyKeys 是可以为空值的key数组
    let token = (TOKEN_KEY && cookie.getCookie(TOKEN_KEY))
    if (!token) {
      const href = window ? window.location.href : ''
      const __params = getUrlParams(href)
      token = __params && __params.token
    }

    config.headers['access-token'] = token
    config.headers['Authorization'] = 'Bearer '+token
    config.headers['Cache-Control'] = 'no-cache'
    config.headers['Accept-Language'] = i18n.locale
    // config.headers.token = token
    // if (config.data) {
    //   config.data.token = token
    // } else if (config.params) {
    //   config.params.token = token
    // }

    if (headers && Object.prototype.toString.call(headers) === '[object Object]') {
      Object.assign(config.headers, headers)
    }
    if (allowEmpty) {
      config.data && delete config.data.allowEmptyKeys
      config.data = filterEmpty(config.data, allowEmptyKeys)
    }

    return config
  }

  /* Request的失败回调 */
  function __requestErrorInterceptor(error) {
    return Promise.reject(error)
  }

  /* Response的成功回调 */
  function __responseSuccessInterceptor({ data }) {
    const { code } = data // 处理业务逻辑code 错误
    if (data && (code == '200' || code == '0')) {
      return Promise.resolve(data)
    }
    return Promise.reject(data)
  }

  /* Response的失败回调 */
  function __responseErrorInterceptor(error) {
    return Promise.reject(error)
  }

  FORMAXIOS.interceptors.request.use(__requestFormSuccessInterceptor, __requestErrorInterceptor)
  FORMAXIOS.interceptors.response.use(__responseSuccessInterceptor, __responseErrorInterceptor)

  return FORMAXIOS
}


const axiosInstance = request({
  TOKEN_KEY: TOKEN_KEY,
  baseUrl: process.env.VUE_APP_BASE_API
})

let isTokenExpire = false

// 二次封装 拦截所有报错给出提示
const service = (config = {}) => {
  return new Promise((resolve, reject) => {
    axiosInstance(config).then(res => {
      resolve(res)
    }).catch(err => {
      // 如果是token失效做统一的路由回到login处理 错误码暂时写死的401，因为后端还没定 后期需要改
      if ([1000, 1001].includes(err.code)) {
        if (!isTokenExpire) {
          isTokenExpire = true
          Message({
            type: 'warning',
            message: i18n.t('common.loginExpired'),
            offset: 100,
            duration: 1500,
            onClose: () => {
              toLoginPage()
            }
          })
        }
      } else {
        // 首先所有的错误都报个错，如果配置了notShowErrMessage则不展示
        if(config.notShowErrMessage !== true){
          Message({
            message: err.message || 'Error',
            type: 'error',
            duration: 3 * 1000
          })
        }
      }

      reject(err)
    })
  })
}

export default service



// WEBPACK FOOTER //
// ./src/assets/js/request.js